import React from 'react';
import cn from 'classnames';
import { format } from 'date-fns';
import { Button, Typography } from 'seagull';
import { InformationLiner24 } from 'seagull/icons';
import { Intent } from "../../infra/access-control";
import styles from "./ChangesApprovalInfoBox.module.scss";
const InfoWrapper = _ref => {
  let {
    displayDisableButton,
    children
  } = _ref;
  return displayDisableButton ? /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, children) : children;
};
export default function ChangesApprovalInfoBox(props) {
  const {
    testid,
    autoApprovalDate,
    className,
    showDisableButton
  } = props;
  return /*#__PURE__*/React.createElement(Typography, {
    className: cn(styles.infoBox, showDisableButton && styles.spaceWithDisable, className),
    skin: "primary"
  }, /*#__PURE__*/React.createElement(InfoWrapper, {
    displayDisableButton: showDisableButton
  }, /*#__PURE__*/React.createElement(InformationLiner24, null), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": testid
  }, autoApprovalDate ? "Will be automatically approved on ".concat(format(autoApprovalDate, 'MMMM d, yyyy'), " ", 'unless approved earlier or if auto-approval is disabled.') : 'Changes are awaiting approval.')), showDisableButton && /*#__PURE__*/React.createElement(Button, {
    onClick: props.onDisable,
    skin: "primaryOutline",
    "data-testid": "disable-auto-approval-button",
    intent: Intent.DeclineAutoApproval,
    loading: props.disabling,
    className: styles.disableButton
  }, "Disable auto-approval"));
}